<template>
	<div class="full-screen">
		<div class="button-row">
			<div
					 class="dimension-button"
					 :class="dim.selected ? 'on' : 'off'"
					 v-for="dim in dimensions"
					 :key="dim.name"
					 @click="selectDimension(dim)">
				<img :src="dim.imageURL" />
			</div>
		</div>

		<div class="button-row" v-if="ask">
			<div v-if="!ask.excludeFromAI" class="gemini-btn wide" @click="excludeFromAI()" style="flex-grow: 3">
				Exclude from AI
			</div>
			<div v-if="ask.excludeFromAI" class="gemini-btn wide" @click="excludeFromAI()" style="flex-grow: 3;text-decoration:line-through;color:maroon">
				<i>Excluded from AI</i>
			</div>
			<div class="gemini-btn wide" style="flex-grow: 3;font-size:22px;" :style="`color: ${ask.stars == 1 ? 'purple' : '#bbbbbb'}`" @click="rateAsk(1)">★</div>
			<div class="gemini-btn wide" style="flex-grow: 3;font-size:22px;" :style="`color: ${ask.stars == 2 ? 'purple' : '#bbbbbb'}`" @click="rateAsk(2)">★★</div>
			<div class="gemini-btn wide" style="flex-grow: 3;font-size:22px;" :style="`color: ${ask.stars == 3 ? 'purple' : '#bbbbbb'}`" @click="rateAsk(3)">★★★</div>
			<div class="gemini-btn wide" style="flex-grow: 3;font-size:22px;" :style="`color: ${ask.stars == 4 ? 'purple' : '#bbbbbb'}`" @click="rateAsk(4)">★★★★</div>
			<input type="date" class="gemini-btn wide" style="flex-grow: 1" alt="Deadline" v-model="deadline" @change="addDeadline()" />
		</div>

		<!-- Intents -->
		<div class="button-row">
			<div class="gemini-btn wide" style="flex-grow: 1" @click="nextAsk('back')">
				&lt;
			</div>
			<div class="gemini-btn wide" style="flex-grow: 1" @click="nextAsk('next')">
				&gt;
			</div>
			<select class="gemini-btn wide" style="flex-grow: 3" v-model="ask.intent" @change="pickIntent()">
  			<option v-for="intent of intents" :key="intent">{{ intent}}</option>
			</select>
			<div class="gemini-btn wide" style="flex-grow: 3" @click="clearLabels()">
				Clear Labels
			</div>
			<div class="gemini-btn wide" style="flex-grow: 3" @click="addAILabels()">
				{{ aiText}}
			</div>
			<div class="gemini-btn wide" style="flex-grow: 3" @click="goToMatches()">
				Matches ({{
						ask.recommendedAdvisors ? ask.recommendedAdvisors.length : 0
				}})
			</div>
		</div>

		<!-- Ask status details -->
		<div class="details">
			<b>{{ getStatus()}}</b> for
			{{ community.name}}.
			{{ ask.recommendedAdvisors ? ask.recommendedAdvisors.length : 0}}
			matches. Last Request Sent: {{ tinyDate(ask.reqSentDate)}}, Received:
			{{ tinyDate(ask.reqReceivedDate)}}
		</div>

		<!-- Ask text for labeling -->
		<p
			 class="ask"
			 :style="`border-top-style:${loading
			 ? 'dashed; border-top-color:red'
			 : 'dotted; border-top-color:green'
			 };`"
			 ref="annotator"
			 @touchend="tag($event)"
			 @pointerup="tag($event)">
			{{ untaggedText}}
		</p>
	</div>
</template>

<script>
import API from "@/services/API";
import Config from '@/utils/config';

export default {
	data() {
		return {
			api: new API(),
			aiText: "Add AI Labels",
			ask: {},
			community: {},
			deadline: "",
			dimensions: [],
			intents: Config.GEMINI_CONFIGS.map(c => c.intent),
			// loading: true,
			untaggedText: ""
		};
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData: async function () {
			this.loadAsk(this.$route.params.ask_id);
			Config.GEMINI_DIMENSIONS.forEach((dim) => {
				this.addDimension(dim.name, dim.color);
			});
		},
		loadAsk(id) {
			// this.loading = true;
			this.api.get(`asks/${id}`).then(ask => {
				this.ask = ask.data;
				if (this.ask) {
					this.deadline = this.ask.deadline ? new Date(this.ask.deadline).toISOString().split('T')[0] : '';
					console.log("Got ask: it is", this.ask)
					if (!this.ask.matchingCriteria.version || this.ask.matchingCriteria.version != 2) {
						console.log("Wrong version, update matching criteria")
						this.api.post(`asks/${this.ask._id}/update-matching-criteria`, {}).then(response => {
							this.ask = response.data;
							console.log("Ask is now updated", this.ask)
						});
					}
					this.aiText = "Add AI Labels";
					this.untaggedText = `${this.ask.subject}\n\n${this.ask.text}`;
					this.dimensions = this.dimensions.map(dim => {
						dim.tags = [...new Set(this.ask.dimensions[dim.name])];
						return dim;
					});
					this.updateTaggedText();
					if (this.ask.community._id) { // It's been mutated
						this.community = this.ask.community;
					} else {
						this.api.get(`communities/${this.ask.community}`).then(res => {
							this.community = res.data;
						});
					}
					// this.loading = false;
				}
			});
		},
		nextAsk(direction) {
			// this.loading = true;
			let dim = this.dimensions.find(d => d.selected)
			this.api.get(`asks/trainer/${dim ? dim.name : "intent"}/${direction}?since=${this.ask.createdAt}`).then(response => {
				if (response.data) {
					this.loadAsk(response.data);
					this.$router.push('/gemini/' + response.data)
				}
			});
		},
		addDimension(name, color) {
			this.dimensions.push({
				name: name,
				color: color,
				imageURL: `../../../static/${name}.png`,
				selected: false,
				tags: []
			});
		},
		selectDimension(dim) {
			for (let i = 0; i < this.dimensions.length; i++) {
				this.dimensions[i].selected = 0;
			}
			dim.selected = 1;
		},
		tag: async function (evt) {
			let selectionInfo = this.fullWordSelection();
			this.updateDimensionTags(selectionInfo);
			this.updateTaggedText();
		},
		updateTaggedText() {
			let html = "";
			let spans = [];
			let maxDepth = 0;
			let locationDetails = this.getTermLocations();

			// Iterate over the text, letter-by-letter, adding start/end span tags as necessary
			for (let i = 0; i < this.untaggedText.length; i++) {
				let starts = locationDetails.filter(d => d.start == i);
				let ends = locationDetails.filter(d => d.end == i);
				// Whenever you come across any end tag(s) close all the spans, then reopen the ones that are remaining
				if (ends.length > 0) {
					// Close the current set of spans
					for (let s = 0; s < spans.length; s++) {
						html += `</span>`
					}
					// Remove the ending ones from the spans array
					for (let e = 0; e < ends.length; e++) {
						spans.splice(spans.findIndex(x => x.id == ends[e].id), 1)
					}
					// Then reopen the remaining spans that are left at the appropriate depth
					for (let s = 0; s < spans.length; s++) {
						html += this.coloredSpan(spans[s].color, spans[s].depth);
					}
				}
				// And then add any new ones in to the html and the spans array, 1 level deeper than the current max
				for (let s = 0; s < starts.length; s++) {
					starts[s].depth = 1 + spans.reduce((max, p) => p.depth > max ? p.depth : max, 0);
					maxDepth = Math.max(maxDepth, starts[s].depth);
					spans.push(starts[s]);
					html += this.coloredSpan(starts[s].color, starts[s].depth);
				}
				html += this.untaggedText.charAt(i);
			}
			this.$refs.annotator.style.lineHeight = maxDepth < 4 ? '1.5em' : (maxDepth < 7 ? '2em' : '2.5em');
			this.$refs.annotator.innerHTML = `${html}`;
		},
		coloredSpan(color, depth) {
			return `<span style='font-weight: 600;border-bottom:3px solid ${color}; padding-bottom: ${(depth - 1) * 4}px'>`
		},
		escapeRegExp(text) {
			return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
		},
		getTermLocations() {
			let locationDetails = [];
			for (let i = 0; i < this.dimensions.length; i++) {
				let dim = this.dimensions[i];
				for (let t = 0; t < dim.tags.length; t++) {
					let txtRe = this.escapeRegExp(dim.tags[t].trim());
					let re = new RegExp(`\\b${txtRe}\\b`, 'gi');
					let matches = [...this.untaggedText.matchAll(re)];
					for (let m = 0; m < matches.length; m++) {
						let match = matches[m];
						locationDetails.push({
							id: locationDetails.length,
							term: dim.tags[t],
							dim: dim.name,
							start: match.index,
							end: match.index + dim.tags[t].length,
							color: dim.color,
							depth: 0
						});
					}
				}
			}
			locationDetails = locationDetails.sort((a, b) => a.start == b.start ? a.end - b.end : a.start - b.start)
			// console.log("Sorted Tag location details:", locationDetails);
			return locationDetails;
		},
		updateDimensionTags(info) {
			if (info.term.length > 1) {
				info.term = info.term.toLowerCase().trim();
				for (let i = 0; i < this.dimensions.length; i++) {
					let dim = this.dimensions[i];
					if (dim.selected) {
						if (info.backwards) {
							dim.tags = dim.tags.filter(t => t.toLowerCase().trim() != info.term);
						} else {
							if (!dim.tags.some(t => t == info.term)) {
								dim.tags.push(info.term);
							}
						}
						// this.loading = true;
						this.api.post(`asks/${this.ask._id}/update-dimension/${dim.name}`, {terms: dim.tags}).then(response => {
							console.log("Ask", dim.name, "dimensions saved.")
							// this.loading = false;
						});
					}
				}
			}
		},
		clearLabels() {
			// this.loading = true;
			this.api.post(`asks/${this.ask._id}/clear-dimensions`, {}).then(ask => {
				this.aiText = "Add AI Labels";
				// this.loading = false;
			});
			for (let i = 0; i < this.dimensions.length; i++) {
				let dim = this.dimensions[i];
				dim.tags = [];
			}
			this.updateTaggedText();
		},
		addDeadline() {
			console.log("add deadline", this.deadline)
			// this.loading = true;
			this.api.post(`asks/${this.ask._id}/deadline`, {deadline: this.deadline}).then(response => {
				// this.loading = false;
			});
		},
		excludeFromAI() {
			// this.loading = true;
			this.ask.excludeFromAI = !this.ask.excludeFromAI;	// toggle value
			this.api.post(`asks/${this.ask._id}/exclude`, {excludeFromAI: this.ask.excludeFromAI}).then(response => {
				// this.loading = false;
			});
		},
		rateAsk(stars) {
			console.log("rate ask", stars)
			this.ask.stars = stars;
			// this.loading = true;
			this.api.post(`asks/${this.ask._id}/stars`, {stars: this.ask.stars}).then(response => {
				// this.loading = false;
			});
		},
		addAILabels() {
			// this.loading = true;
			this.aiText = "Analyzing content...";
			this.api.post(`asks/${this.ask._id}/add-ai-labels`, {}).then(res => {
				this.ask = res.data;
				this.dimensions = this.dimensions.map(dim => {
					dim.tags = this.ask.dimensions[dim.name];
					return dim;
				});
				this.aiText = "AI Labels Added";
				this.updateTaggedText();
				// this.loading = false;
			});
		},
		pickIntent() {
			// this.loading = true;
			this.api.post(`asks/${this.ask._id}/update-intent`, {intent: this.ask.intent}).then(response => {
				// this.loading = false;
				console.log("Intent updated to ", this.ask.intent);
			});
		},
		goToMatches() {
			window.open(`/gemini-match/${this.ask._id}`, "_self");
		},
		fullWordSelection() {
			let sel;
			let backwards = false;
			if (window.getSelection && (sel = window.getSelection()).modify) {
				sel = window.getSelection();
				if (!sel.isCollapsed) {
					// Detect if selection is backwards
					let range = document.createRange();
					range.setStart(sel.anchorNode, sel.anchorOffset);
					range.setEnd(sel.focusNode, sel.focusOffset);
					backwards = range.collapsed;
					range.detach();
					// modify() works on the focus of the selection
					let endNode = sel.focusNode;
					let endOffset = sel.focusOffset;
					sel.collapse(sel.anchorNode, sel.anchorOffset);
					let direction = [];
					if (backwards) {
						direction = ['backward', 'forward'];
					} else {
						direction = ['forward', 'backward'];
					}
					sel.modify("move", direction[0], "character");
					sel.modify("move", direction[1], "word");
					sel.extend(endNode, endOffset);
					sel.modify("extend", direction[1], "character");
					sel.modify("extend", direction[0], "word");
				}
			}
			return {
				backwards: backwards,
				term: sel.toString().toLowerCase()
			}
		},
		tinyDate: function (dt) {
			const d = new Date(dt);
			return dt ? `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear() - 2000}` : 'N/A';
		},
		getStatus: function () {
			switch (this.ask.status) {
				case '(0) New':
					return 'New';
				case '(1) Tagged':
					return 'Match Request';
				case '(2) Matched':
					return 'Send Request';
				case '(3) Dispatched':
					return 'Active';
				case '(4) Reminded':
					return 'Reminded';
				case '(5) Responded':
					return 'Active';
				case '(6) Feedback added':
					return 'Active';
				case '(6) Feedback requested':
					return 'Active';
				case '(7) Closed':
					return 'Closed';
				case '(8) Rejected':
					return 'Rejected';
				case 'Add Tags':
					return 'Add Tags';
				case 'Review':
					return 'Review';
				case 'In Review':
					return 'In Review';
				case 'Reviewed':
					return 'Reviewed';
				case 'Pending':
					return 'Pending';
			}
		}
	}
}
</script>

<style scoped>
.intent-picker {
	left: 20px;
	top: 150px;
}

.wide {
	border: 2px solid rgba(45, 45, 238, 0.5);
	background-color: rgba(0, 124, 248, 0.1);
	color: black;
}

.ask {
	border-top: 1px dotted black;
	margin: 2px 0px 0px 0px;
	padding-top: 2px;
	white-space: pre-line;
	overflow: auto;
	font-size: 16px;
	line-height: 1.5em;
}

.date-picker {
	text-align: center;
	font-size: 14px;
	border-radius: 3px;
	border: 2px solid rgba(45, 45, 238, 0.5);
	background-color: #bcdbf6;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/gemini/AITrainer.vue